module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 3.91684","quantity":0.03917},{"color":"#9dc4b5","label":" 3.91684- 6.96827","quantity":0.06968},{"color":"#e6efc3","label":" 6.96827- 8.28367","quantity":0.08284},{"color":"#ffe89e","label":" 8.28367- 9.77591","quantity":0.09776},{"color":"#f5af7f","label":" 9.77591- 11.95517","quantity":0.11955},{"color":"#ed6d32","label":" 11.95517- 28.75538","quantity":0.28755}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_100_return_10.json
// module id = WJwC
// module chunks = 171